/**
 * Organization Switcher
 * Handles switching between production and sandbox organizations
 */

document.addEventListener('DOMContentLoaded', function() {
    const orgSwitcher = document.getElementById('orgSwitcher');

    if (!orgSwitcher) {
        return;
    }

    // Handle organization change
    orgSwitcher.addEventListener('change', function() {
        const targetOrgId = parseInt(this.value);
        const currentOrgId = parseInt(this.dataset.currentOrgId);
        const selectElement = this;

        if (targetOrgId === currentOrgId) {
            return;
        }

        // Confirm the switch
        const selectedOption = this.options[this.selectedIndex];
        const orgName = selectedOption.textContent.trim();
        const isSandbox = selectedOption.textContent.includes('(Training)');

        let confirmMessage = `Switch to <strong>${orgName}</strong>?<br><br>`;
        let confirmTitle = '';
        let confirmClass = 'btn-primary';

        if (isSandbox) {
            confirmTitle = 'Switch to Training Environment';
            confirmMessage += 'You are switching to a training sandbox. Any changes you make will be reset nightly.';
            confirmClass = 'btn-warning';
        } else {
            confirmTitle = 'Switch to Production Environment';
            confirmMessage += 'You are switching back to your production environment.';
            confirmClass = 'btn-success';
        }

        // Use modal confirmation if available, otherwise fall back to confirm()
        const modalElement = document.getElementById('appConfirmationModal');
        if (typeof showConfirmation === 'function' && modalElement) {
            try {
                showConfirmation({
                    title: confirmTitle,
                    message: confirmMessage,
                    confirmText: 'Switch Environment',
                    confirmClass: confirmClass,
                    onConfirm: async () => {
                        // Disable the selector while switching
                        selectElement.disabled = true;
                        await performSwitch(selectElement, targetOrgId, currentOrgId);
                    },
                    onCancel: () => {
                        // User cancelled, revert the selection
                        selectElement.value = currentOrgId;
                    }
                });
            } catch (e) {
                console.error('Confirmation modal error, falling back to confirm():', e);
                // Fall through to browser confirm
                const plainMessage = confirmMessage.replace(/<br>/g, '\n').replace(/<\/?strong>/g, '');
                if (!confirm(plainMessage)) {
                    selectElement.value = currentOrgId;
                    return;
                }
                selectElement.disabled = true;
                performSwitch(selectElement, targetOrgId, currentOrgId);
            }
        } else {
            // Fallback to browser confirm if modal system not available
            const plainMessage = confirmMessage.replace(/<br>/g, '\n').replace(/<\/?strong>/g, '');
            if (!confirm(plainMessage)) {
                selectElement.value = currentOrgId;
                return;
            }
            selectElement.disabled = true;
            performSwitch(selectElement, targetOrgId, currentOrgId);
        }
    });

    // Extracted switch logic to reusable async function
    async function performSwitch(selectElement, targetOrgId, currentOrgId) {

        try {
            const response = await fetch('/switch-organization', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    organization_id: targetOrgId
                })
            });

            // If session expired, auth.php redirects to sign-in — fetch follows
            // the redirect and we get HTML instead of JSON.
            // Also check content-type since Refresh headers aren't detected by response.redirected.
            if (response.redirected) {
                window.location.href = '/sign-in';
                return;
            }

            const contentType = response.headers.get('content-type') || '';
            if (!contentType.includes('application/json')) {
                // Session likely expired — got HTML redirect instead of JSON
                window.location.href = '/sign-in';
                return;
            }

            const data = await response.json();
            console.log('Switch organization response:', data);

            if (data.success) {
                console.log('Organization switched successfully, redirecting...');

                // Redirect to home or specified page (force full page reload)
                const redirectUrl = data.redirect || '/home';
                console.log('Redirecting to:', redirectUrl);

                // Use location.replace to force a full page reload and clear any cached data
                window.location.replace(redirectUrl);
            } else {
                throw new Error(data.message || 'Failed to switch organizations');
            }

        } catch (error) {
            console.error('Organization switch error:', error);

            // Re-enable selector and revert selection
            selectElement.disabled = false;
            selectElement.value = currentOrgId;

            // Show error message
            const errorMessage = error.message || 'Failed to switch organizations. Please try again.';
            if (typeof showToast === 'function') {
                showToast({
                    message: errorMessage,
                    type: 'danger',
                    title: 'Error'
                });
            } else {
                console.error('showToast not available, error:', errorMessage);
            }
        }
    }
});
